import { LockSpec } from '@sparemin/api-sdk';
import { createLockChecker, LockChecker } from '@sparemin/embed-config';
import { createSelector } from 'reselect';

import { lockSpecsSelector } from 'redux/modules/entities/selectors';
import { State } from 'redux/types';
import { embedConfigDataSelector } from './legacy-selectors';

const embedConfigLockSpecUuidSelector = (state: State): string | undefined =>
  embedConfigDataSelector(state)?.lockSpec?.uuid;

/**
 * Resolves the full LockSpec body for the loaded embed config.  The
 * embedConfig itself only carries a uuid reference; the body lives in
 * entities.lockSpecs and is fetched alongside other editor dependencies.
 */
export const embedConfigLockSpecSelector = createSelector(
  embedConfigLockSpecUuidSelector,
  lockSpecsSelector,
  (uuid, lockSpecs): LockSpec | undefined =>
    uuid
      ? (lockSpecs?.get(uuid)?.toJS()?.lockSpec as LockSpec | undefined)
      : undefined,
);

/**
 * Shared LockChecker for the loaded project.  Per-feature lock aggregators
 * compose on this rather than calling createLockChecker themselves so the
 * checker is memoized across renders.
 */
export const lockCheckerSelector = createSelector(
  embedConfigLockSpecSelector,
  (lockSpec): LockChecker => createLockChecker(lockSpec),
);
